<!-- show.wxml -->
<template>
    <div class="container">
        <!-- banner -->
        <div class="banner">
            <nut-swiper
                direction="horizontal"
                :loop="true"
                :canDragging="false"
                :paginationVisible="true"
                :swiperData="detail.image"
                :autoPlay=3000
            >
                <div v-for="(item,index) in detail.image" :key="index" class="nut-swiper-slide">
                    <div class="image">
                        <img :src="item.file_path" width="100%" height="100%"/>
                    </div>
                </div>
            </nut-swiper>
        </div>
        <!-- banner end -->
        <div class="goods-name">
            {{detail.goods_name}}
            <!--            <div class="share-box" @click='kefu'>-->
            <!--                <div class="iconfont icon-kefu1"></div>-->
            <!--                <div class="text">客服</div>-->
            <!--            </div>-->
        </div>
        <div class="price-box clearfix">
            <div class="price"><span style="font-size: 12px">$</span><span
                style="font-size: 18px">{{detail.is_spike == 10 ? detail.spike_price : goods_price}}</span>
            </div>
            <div class="mark-price" v-if="line_price>0">${{line_price}}</div>
            <div class="price" style="float: right;font-size: 12px;"
                 v-if="detail.percentage == 10 && detail.percentage_eduction > 0">降价: {{detail.percentage_eduction}}%
            </div>
        </div>
        <div class="data-box clearfix">
            <div class="stock">已售：{{detail.goods_sales}}</div>
            <div class="volume">剩余：{{stock_num}}</div>
        </div>
        <div class="divider-line"></div>
        <div class="param-item" v-if="detail.is_spike == 10">
            <span class="title">秒杀倒计时：</span>
            <div class="text" style="color: #ff5656;font-size: 14px;">距离结束还剩
                <nut-countdown
                    show-days
                    show-plain-text
                    :end-time="detail.spike_end_time * 1000"
                >
                </nut-countdown>
            </div>
        </div>
        <div class="divider-line" v-if="detail.is_spike == 10"></div>
        <div class="param-item">
            <span class="title">配送规则①：</span>
            <div class="text">
                可派送区域$30包邮(结算时需选择送货上门)
            </div>
        </div>
        <div class="param-item">
            <span class="title">配送规则②：</span>
            <div class="text">
                邮寄(信用卡/微信支付)$48包邮，2-5天美国直邮。
            </div>
        </div>
        <div class="divider-line" style="border-top: 1px solid #e8e8e8;margin-bottom: 5px;"></div>
        <!--   猜你喜欢     -->
        <div class="reco-product" v-if="autoRecoproductlist">
            <div class="product-detail-title">猜你喜欢：</div>
            <div class="reco-product-list">
                <div class="reco-product-scroll menu-item-scroll">
                    <div class="reco-product-item" v-for="(item,index) in autoRecoproductlist" :key="index">
                        <div class="img" @click="toshopcard(item.goods_id)">
                            <img :src="item.file_name" width="100%" height="100%"/>
                        </div>
                        <div class="text-box">
                            <div class="title">{{item.goods_name}}</div>
                            <div class="price">${{item.goods_price}}</div>
                            <div class="old" v-if="item.line_price>0">${{item.line_price}}</div>
                            <div class="addshop skeleton-radius" @click="addCart(item.goods_id)">
                                <div class="iconfont icon-gouwuche" style="color: #fff;font-size: 14px"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 评价 -->
        <div class="show-content" v-if="detail.comment_data_count">
            <div class="title-box">
                <div class="title">用户评价 ({{ detail.comment_data_count }}条) <router-link
                    :to="{path:'/goods/common?goods_id=' + detail.goods_id}" style="float: right;color: #666;">查看更多<span class="iconfont icon-jiantou1"></span></router-link></div>
            </div>
            <div class="goods-comment-box" v-for="(item,index) in detail.comment_data" :key="index">
                <div class="cont-box">
                    <div class="name">{{ item.user.nickName }}</div>
                    <div class="pf">
                        <div v-if="item.score == 10">
                            <nut-rate
                                value="5"
                                size="14"
                                spacing="1"
                                :readOnly="true"
                            >
                            </nut-rate>
                        </div>
                        <div v-else-if="item.score <30 ">
                            <nut-rate
                                value="1"
                                size="14"
                                spacing="1"
                                :readOnly="true"
                            >
                            </nut-rate>
                        </div>
                        <div v-else-if="item.score <20">
                            <nut-rate
                                value="3"
                                size="14"
                                spacing="1"
                                :readOnly="true"
                            >
                            </nut-rate>
                        </div>
                    </div>
                </div>
                <div class="common-content">
                    <div class="content">
                        {{item.content}}
                    </div>
                    <div class="time">{{item.create_time}}</div>
                </div>
            </div>
        </div>
        <!-- 商品详情 -->
        <div class="show-content">
            <div class="title-box">
                <div class="title">商品详情</div>
            </div>
            <div class="content" v-html="detail.content"></div>
        </div>
        <div class="bottom-box">
            <div class="bottom-aside">
                <router-link to="/" class="to-index">
                    <div class="iconfont icon-shouye1"></div>
                    <div class="text">首页</div>
                </router-link>
                <router-link to="/order/cart" class="favor gouwu">
                    <div class="iconfont icon-gouwuche"
                         style="position: relative;z-index: -1"></div>
                    <div class="cart-total-num" v-if="cart_total_num>0">{{cart_total_num}}</div>
                    <div class="text">购物车</div>
                </router-link>
                <div :class="['favor',favor == 200 ? 'favor-active':'']" @click="setFavor">
                    <div class="iconfont icon-aixin1"></div>
                    <div class="text">收藏</div>
                </div>
                <div class="buy-btn-box">
                    <div class="add-cart" @click="showAddCart('addCart')">
                        <div class="text">加入购物车</div>
                    </div>
                    <div class="go-buy" @click="showAddCart('buyNow')">
                        <div class="text">立即购买</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 规格选择 -->
        <nut-popup position="bottom" closeable close-icon="cross" v-model="isShowSku" :style="{height:'50%'}"
                   close-icon-position="top-right">
            <div class="goods-sku-aside">
                <div class="sku-content">
                    <div slot="list" class="sku-form">
                        <div class="goods-detail clearfix">
                            <div class="image-box">
                                <img :src="skuCoverImage" class="skeleton-rect" style="max-width: 80%"/>
                            </div>
                            <div class="content-box">
                                <div class="title text-flow skeleton-rect">{{detail.goods_name}}</div>
                                <div class="price-box skeleton-rect">
                                    <div class="price">${{detail.is_spike == 10 ? detail.spike_price : goods_price}}
                                    </div>
                                    <div class="mark-price" v-if="line_price>0">${{line_price}}</div>
                                </div>
                                <div class="volume-box skeleton-rect">
                                    <div class="volume">已售：{{detail.goods_sales}}</div>
                                    <div class="stock">剩余：{{stock_num}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="sku-list-box goods-attr">
                            <div class="group-item" v-for="(attr,attr_idx) in goodsMultiSpec.spec_attr" :key="attr_idx">
                                <div class="tips-text">{{ attr.group_name }}</div>
                                <div :class="['spec-item',item.checked ? 'cur' : '']"
                                     v-for="(item,item_idx) in attr.spec_items" :key="item_idx"
                                     @click="onSwitchSpec(attr_idx,item_idx)">
                                    {{ item.spec_value }}
                                </div>
                            </div>
                            <div class="goods-num-box clearfix">
                                <div class="num-name">数量</div>
                                <div class="num-box">
                                    <div class="add-num iconfont icon-plus-bold" @click="goodsAddNum"></div>
                                    <div class="num-input">
                                        <input type="number" name="goods_num" :value="goods_num" disabled/>
                                    </div>
                                    <div class="remove-num iconfont icon-minus-bold" @click="goodsReomoveNum"></div>
                                </div>
                            </div>
                            <button class="submit-add" @click="onConfirmSubmit">确定</button>
                        </div>
                    </div>
                </div>
            </div>
        </nut-popup>
    </div>
</template>
<script>

const util = require('../../utils/util.js');
// 记录规格的数组
let goodsSpecArr = [];
export default {
    name: 'GoodsShow',
    data() { //默认数据
        return {
            buyType: '',
            isPosterCreat: false,
            detail: {},
            goods_sku: [],
            userInfo: {}, //用户信息
            goods_id: 0, // 商品 id
            goods_num: 1, //购买数量
            goods_sku_id: 0, // 规格id
            cart_total_num: this.GLOBAL.cart_total_num, // 购物车商品总数量
            goodsMultiSpec: {}, // 多规格信息
            goods_price: 0,
            line_price: 0,
            autoRecoproductlist: null,
            skuCoverImage: '',
            favor: 0,
            specData: null,
            stock_num: 0,
            isLogin: false, // 是的登陆
            isShowParam: false, //是否隐藏参数
            isShowSku: false, //是否隐藏规格
            imgUrl: '', // 海报图片路径
        }
    },
    created() { //视图加载前执行
        let _this = this,
            scene = _this.getSceneData(_this.$route.query);
        _this.goods_id = _this.$route.query.goods_id ? _this.$route.query.goods_id : scene.gid;
        if (_this.$route.query.integral_id) {
            _this.$ls.set('integral_id', _this.$route.query.integral_id);
        }
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });

        // 获取商品详情
        _this.getDetail();

    },
    mounted() { //视图加载完成执行
        let _this = this;
        // 获取购物车数量
        _this.setTabBarBadge();
        // 获取自动推荐商品
        _this.getAutoGoods();
        // 获取收藏列表
        _this.getFavor();
    },
    methods: {

        // 去商品详情
        toshopcard(goods_id) {
            this.navigationTo('/goods/supper', {goods_id: goods_id});
        },

        // 是否收藏该商品
        getFavor() {
            let _this = this;
            _this._get('goods/collectStatus', {
                goods_id: _this.goods_id
            }, res => {
                _this.favor = res.code;
            });

        },

        /**
         *  添加购物车
         */
        addCart: function (id) {
            let _this = this;
            _this._post_form('cart/add', {
                goods_id: id,
                goods_num: 1,
                goods_sku_id: 0,
            }, result => {
                _this.$toast.success(result.msg);
                // 更新 Tabbar 组件中购物车数量
                _this.cart_total_num = result.data.cart_total_num;
            })
        },

        kefu() {
            let _this = this;
            _this.$dialog({
                id: 'my-dialog',
                title: "联系客服",
                noCancelBtn: true,
                okBtnTxt: '点击复制 E-mail',
                onOkBtn: function () {
                    _this.$copyText('sfqxusa@yahoo.com').then(function (e) {
                        _this.$toast.success('复制 E-mail 成功');
                    })
                    this.close(); //关闭对话框
                },
                content: "如果购物过程中遇到问题<br/>请联系官方E-mail: sfqxusa@yahoo.com"
            });
        },

        /**
         * 获取自动推荐商品(猜你喜欢)
         */
        getAutoGoods: function () {
            let _this = this;
            if (_this.$ls.get('autogoods' + _this.goods_id)) {
                _this.autoRecoproductlist = _this.$ls.get('autogoods' + _this.goods_id);
                return false;
            }
            _this._get('goods/autoRecommend', {
                goods_id: _this.goods_id
            }, res => {
                var autoRecoproductlist = [];
                var list = res.data.list;
                for (let i = 0; i < list.length; i++) {
                    autoRecoproductlist[i] = {
                        file_name: list[i].goods_image,
                        goods_name: list[i].goods_name,
                        goods_price: list[i].goods_sku.goods_price,
                        line_price: list[i].goods_sku.line_price,
                        goods_id: list[i].goods_id
                    }
                }
                // 设置缓存
                _this.$ls.set('autogoods' + _this.goods_id, autoRecoproductlist, 300 * 1000);
                _this.autoRecoproductlist = autoRecoproductlist;
            });

        },

        // 复制当前地址
        doCopy() {
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            let _this = this;
            let params = encodeURIComponent(window.location.href + '&integral_id=' + _this.getUserId());
            _this._post_form('goods/posterH5', {
                goods_id: _this.goods_id,
                params: params,
            }, (result) => {
                _this.imgUrl = result.data.qrcode;
                _this.loading.hide();
                _this.creatPosterTap();
            });
        },


        /**
         * 收藏商品
         */
        setFavor: function () {
            let _this = this;
            _this._post_form('goods/addCollect', {
                goods_id: _this.goods_id,
                status: _this.favor == 200 ? 0 : 1,
            }, (res) => {
                if (res.code) {
                    _this.$toast.success(res.msg);
                    _this.favor = _this.favor == 200 ? 0 : 200
                }
            });
        },

        // 获取商品详情
        getDetail() {
            let _this = this;
            _this._get('goods/detail', {
                goods_id: _this.goods_id
            }, res => {
                // 初始化商品详情数据
                let data = _this._initGoodsDetailData(res.data);
                _this.setData(data);
                document.title = data.detail.goods_name + '- 商品详情 - 三坊七巷 US GO'; // 网页标题
                _this.loading.hide();
                if (data.detail.is_spike == 10) {
                    _this.$notify.text('本商品特价限时秒杀中,请尽快下单购买', {
                        duration: 0,
                    });
                }
            });
        },

        /**
         * 初始化商品详情数据
         */
        _initGoodsDetailData(data) {
            let _this = this;
            // 商品详情
            let goodsDetail = data.detail;

            // 商品价格/划线价/库存
            data.goods_sku_id = goodsDetail.goods_sku.spec_sku_id;
            data.goods_price = goodsDetail.goods_sku.goods_price;
            data.line_price = goodsDetail.goods_sku.line_price;
            data.stock_num = goodsDetail.goods_sku.stock_num;
            // 商品封面图(确认弹窗)
            data.skuCoverImage = goodsDetail.goods_image;
            // 多规格商品封面图(确认弹窗)
            if (goodsDetail.spec_type == 20 && goodsDetail.goods_sku['image']) {
                data.skuCoverImage = goodsDetail.goods_sku['image']['file_path'];
            }
            // 初始化商品多规格
            if (goodsDetail.spec_type == 20) {
                data.goodsMultiSpec = _this._initManySpecData(goodsDetail.goods_multi_spec);
            }
            return data;
        },

        /**
         * 初始化商品多规格
         */
        _initManySpecData(data) {
            let goodsSpecArr = [];
            for (let i in data.spec_attr) {
                for (let j in data.spec_attr[i].spec_items) {
                    if (j < 1) {
                        data.spec_attr[i].spec_items[0].checked = true;
                        goodsSpecArr[i] = data.spec_attr[i].spec_items[0].item_id;
                    }
                }
            }
            return data;
        },

        /**
         * 点击切换不同规格
         */
        onSwitchSpec(attrIdx, itemIdx) {
            let _this = this,
                goodsMultiSpec = _this.goodsMultiSpec;
            for (let i in goodsMultiSpec.spec_attr) {
                for (let j in goodsMultiSpec.spec_attr[i].spec_items) {
                    if (attrIdx == i) {
                        goodsMultiSpec.spec_attr[i].spec_items[j].checked = false;
                        if (itemIdx == j) {
                            goodsMultiSpec.spec_attr[i].spec_items[itemIdx].checked = true;
                            goodsSpecArr[i] = goodsMultiSpec.spec_attr[i].spec_items[itemIdx].item_id;
                        }
                    }
                }
            }
            _this.goodsMultiSpec = goodsMultiSpec
            // 更新商品规格信息
            _this._updateSpecGoods();
        },

        /**
         * 更新商品规格信息
         */
        _updateSpecGoods() {
            let _this = this,
                specSkuId = goodsSpecArr.join('_');
            // 查找skuItem
            let spec_list = _this.goodsMultiSpec.spec_list,
                skuItem = spec_list.find((val) => {
                    return val.spec_sku_id == specSkuId;
                });
            // 记录goods_sku_id
            // 更新商品价格、划线价、库存
            if (typeof skuItem === 'object') {
                _this.goods_sku_id = skuItem.spec_sku_id
                _this.goods_price = skuItem.form.goods_price
                _this.line_price = skuItem.form.line_price
                _this.stock_num = skuItem.form.stock_num
                _this.skuCoverImage = skuItem.form.image_id > 0 ? skuItem.form.image_path : _this.detail.goods_image
            }
        },

        /**
         * 显示多规格
         */
        showAddCart: function (type) {
            let _this = this;
            _this.isShowSku = true
            _this.buyType = type
        },

        /**
         * 关闭多规格
         */
        hiddenGoodsSku: function () {
            this.isShowSku = false
        },


        /**
         * 单选按钮切换
         */
        radioChange: function (item, sku) {
            let _this = this;
            _this.param[item.group_dirname] = sku.sku_id;
        },

        /**
         * 购买数量加
         */
        goodsAddNum: function () {
            if (this.goods_num < this.stock_num) {
                this.goods_num = ++this.goods_num
            } else {
                this.$toast.warn('超出购买最大数量！');
            }
        },

        /**
         *  购买数量减
         */
        goodsReomoveNum: function () {
            if (this.goods_num > 1) {
                this.goods_num = --this.goods_num;
            }
        },

        /**
         * 加入购物车and立即购买
         */
        onConfirmSubmit() {
            let _this = this;
            let submitType = _this.buyType;
            if (submitType === 'buyNow') {
                _this.navigationTo('/flow/checkout', {
                    order_type: 'buyNow',
                    goods_id: _this.goods_id,
                    goods_num: _this.goods_num,
                    goods_sku_id: _this.goods_sku_id,
                })
            } else if (submitType === 'addCart') {
                // 加入购物车
                _this._post_form('cart/add', {
                    goods_id: _this.goods_id,
                    goods_num: _this.goods_num,
                    goods_sku_id: _this.goods_sku_id,
                }, (result) => {
                    _this.$toast.success(result.msg);
                    _this.setData(result.data);
                    _this.hiddenGoodsSku();
                });
            }
        },


    },
    //切记页面销毁需要销毁
    destroyed() {
        let _this = this;
        // 销毁通知
        _this.$notify.text('本商品特价限时秒杀中,请尽快下单购买', {
            duration: 1,
        });
        _this.loading.hide();
    }
}
</script>
<style lang="scss" scoped>
@import "show.scss";
</style>
